import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
import React from 'react';
import { Box } from '../box';
const Container = styled(Box)({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    border: 0
});
export const SrOnly = (props) => {
    return (_jsx(Container, { className: "sr-only", component: props.component, children: props.children }));
};
